import {COLLECTION_EXAM_MODULE} from '@cp/model';
import {collection, CollectionReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

const SUBCOLLECTION_SEED_QUESTION = 'seedQuestions';

/** Firestore document shape (timestamps as stored). */
export type SeedQuestionDoc = Record<string, unknown>;

export default function getSeedQuestionCollectionRef(moduleId: string): CollectionReference<SeedQuestionDoc> {
  return collection(
    firebaseFirestore,
    COLLECTION_EXAM_MODULE,
    moduleId,
    SUBCOLLECTION_SEED_QUESTION,
  ) as CollectionReference<SeedQuestionDoc>;
}
